

















































import { Component, Prop, Vue } from 'vue-property-decorator'
import { Form } from 'element-ui'
import FixRequestUploader from './FixRequestUploader.vue'
import { IFixRequest } from '@/api/types'
import { sendFixRequest } from '@/api/orders'

@Component({
  name: 'FixRequestDialog',
  components: {
    FixRequestUploader
  }
})
export default class extends Vue {
  @Prop({ default: false }) dialogVisible!: boolean;
  @Prop({ type: Object }) value!: IFixRequest;

  imageUrl = ''

  private defaultFixRequest: IFixRequest = {
    orderId: 0,
    instructions: '',
    attachment: null,
    modelId: null
  };

  private fixRequestForm = Object.assign({}, this.defaultFixRequest);
  private loading = false;
  private validateRequire = (rule: any, value: string, callback: Function) => {
    if (value === '') {
      callback(new Error(rule.field + ' is required'))
    } else {
      callback()
    }
  };

  private rules = {
    instructions: [{ validator: this.validateRequire }]
  };

  created() {
    this.fixRequestForm = Object.assign({}, this.value)
  }

  mounted() {
    this.imageUrl = ''
  }

  handleClose() {
    this.$emit('close', true)
  }

  getAttachment(param: File) {
    this.fixRequestForm.attachment = param
  }

  editFloorplan() {
    window.open(`https://editor.cubi.casa/?c=capture&m=${this.fixRequestForm.modelId}&exp=d40c5e6c-979a-45ca-a31b-711f60a5e34e-gla`, '_blank')
  }

  async submitForm() {
    const frm = this.$refs.fixRequestForm as Form
    // console.log(`Submit Fix request: ${this.fixRequestForm.orderId}.`)
    // console.log(`Attachment: ${this.fixRequestForm.attachment}`)
    // console.log(`Instructions: ${this.fixRequestForm.instructions}.`)
    frm.validate(async(valid) => {
      if (valid) {
        this.loading = true
        console.log('Sending Fix request. ')
        await sendFixRequest(this.fixRequestForm.orderId, this.fixRequestForm.instructions, this.fixRequestForm.attachment)
        this.loading = false
        this.$notify({
          title: 'Success',
          message: `Fix Request for ${this.fixRequestForm.orderId} submitted successfully.`,
          type: 'success',
          duration: 2000
        })
        this.dialogVisible = false
        this.handleClose()
        return true
      } else {
        console.log('Validation errors!')
      }
      this.loading = false
      return false
    })
  }

  cancelForm() {
    this.dialogVisible = false
  }
}
